import { useCallback, useRef, useState } from 'react';

export function useScrollIndicator() {
  const [hasMoreBelow, setHasMoreBelow] = useState(false);
  const mainRef = useRef<HTMLElement>(null);

  const checkScroll = useCallback(() => {
    const el = mainRef.current;
    if (!el) return;
    setHasMoreBelow(el.scrollTop + el.clientHeight < el.scrollHeight - 1);
  }, []);

  return { mainRef, hasMoreBelow, onScroll: checkScroll, checkScroll };
}
